import { FormControl, FormHelperText, InputLabel, Select, SelectProps } from '@mui/material';
import { ReactNode } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

interface MuiSelectControlledProps {
  selectProps: {
    name: string;
    defaultValue?: string;
    label?: string;
    placeholder?: string;
  };
  children: ReactNode;
  styles?: any;
}

export function MuiSelectControlled({
  selectProps,
  children,
  styles = {},
  ...rest
}: MuiSelectControlledProps & Omit<SelectProps, keyof MuiSelectControlledProps>) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = !!errors[selectProps.name];

  return (
    <FormControl fullWidth error={error} sx={styles}>
      {selectProps.label && (
        <InputLabel id={`${selectProps.name}-label`}>{selectProps.label}</InputLabel>
      )}
      <Controller
        control={control}
        name={selectProps.name}
        defaultValue={selectProps.defaultValue ?? ''}
        render={({ field }) => (
          <Select
            labelId={`${selectProps.name}-label`}
            id={`${selectProps.name}-select`}
            label={selectProps.label}
            {...field}
            {...rest}
            sx={{
              height: 'unset',
            }}
          >
            {children}
          </Select>
        )}
      />
      <FormHelperText>
        {error ? String(errors[selectProps.name]?.message) : ''}
      </FormHelperText>
    </FormControl>
  );
}
